import type { AgreementConsentFieldName } from './types';

export const AGREEMENT_CONSENT_FIELD_NAMES = [
  'consent_electronic_delivery_via_email',
  'consent_text_messages_regarding_aba_services',
  'consent_electronic_signature_platform',
  'consent_complete_required_assessments',
  'consent_paper_document_delivery_notice',
  'consent_electronic_delivery_freely_given',
] as const satisfies ReadonlyArray<AgreementConsentFieldName>;

export const AGREEMENT_INITIAL_VALUES = {
  consent_electronic_delivery_via_email: false,
  consent_text_messages_regarding_aba_services: false,
  consent_electronic_signature_platform: false,
  consent_complete_required_assessments: false,
  consent_paper_document_delivery_notice: false,
  consent_electronic_delivery_freely_given: false,
  printed_name: '',
  signature: '',
  signature_date: null,
} as const;
